import { IApiPunchclockTime, IPunchclockTime } from './IPunchclockTime'

class Transformer {
  static transform(data: IApiPunchclockTime): IPunchclockTime {
    return {
      id: data.id,
      userId: data.attributes.user_id,
      punchStartedAt: data.attributes.punch_started_at,
      punchEndedAt: data.attributes.punch_ended_at || null,
      correctionStartedAt: data.attributes.correction_started_at || null,
      correctionEndedAt: data.attributes.correction_ended_at || null,
      approvedAt: data.attributes.approved_at || null,
    }
  }
}

export default Transformer
